export const fonts = {
  body: `myriad-pro, sans-serif`,
  heading: `Stick a Round, sans-serif`
};
